exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-projects-friendly-reader-tsx": () => import("./../../../src/pages/projects/friendly-reader.tsx" /* webpackChunkName: "component---src-pages-projects-friendly-reader-tsx" */)
}

